/* Re-solving the route, from wherever asks.
 *
 * Lifted out of `Chart.svelte`, which used to own it as a local function and
 * pass it down to the route panel as a prop. Under the panel registry a panel
 * is a value with no props, so the one thing it needs from the chart has to be
 * reachable by name instead.
 *
 * ═══ WHY A SETTING CHANGE RE-SOLVES RATHER THAN RE-DISPLAYS ═══
 *
 * The route IS the answer to a question the passage settings are part of. Tick
 * USE CURRENTS and the router does a different search — a time-dependent one
 * through the gates — so leaving the old line on the chart beside the new
 * checkbox would be showing a plan that no longer matches the settings printed
 * under it.
 */
import { autoroute } from '@gennetay/chart-core/lib/autoroute.svelte';
import { editor } from '@gennetay/chart-core/lib/editor.svelte';
import { routePlan } from '@gennetay/chart-core/lib/routeplan.svelte';
import { panels } from '@gennetay/chart-ui/shell';
import { departures } from './departures.svelte';

/** Leave the panel and put the route tool in its first-tap state. */
export function planRoute(): void {
  panels.close();
  if (!routePlan.armed) routePlan.arm();
}

/** Re-solve the same two points. */
export async function resolveRoute(): Promise<void> {
  const a = routePlan.start;
  const b = routePlan.end;
  if (!a || !b) return;
  await autoroute.route(a, b, routePlan.draftM);
  if (autoroute.result && autoroute.result.length >= 2) editor.startDraft(autoroute.result);
  /* The departure window was solved against the OLD route. Cleared rather than
   * left showing: a ranked list of times for a route that no longer exists is
   * the most confidently wrong thing this app could put on screen. */
  departures.clear();
}
